// import React from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { server } from "../../common";

// const initialValues = {
//   name: "",
//   mobile: "",
//   email: "",
//   address: "",
//   amc_divisional_office: "",
//   police_station: "",
//   traffice_office: "",
//   fire_station: "",
//   shop_name: "",
//   shop_owner_name: "",
//   shop_adderess: "",
//   applicant: "",
//   appl_type: "",
//   murti_type: "",
//   registration: "",
//   start_date: "",
//   last_date: "",
//   place_height: "",
//   fire_measures_implemented: "",
//   pathway_clear: "",
//   place: "",
//   place_type: "",
//   adharcard: null,
//   affidavit_type: null,
//   place_owner_noc: null,
//   property_tax_receipt: null,
// };

// const MurtikarForm = () => {
//   const formik = useFormik({
//     initialValues: initialValues,
//     validationSchema: Yup.object({
//       name: Yup.string().required("Enter a Fullname"),
//       email: Yup.string().required("Enter a Email Id"),
//       mobile: Yup.string()
//         .matches(/^[6-9]\d{9}$/, "Please enter a valid Indian mobile number")
//         .required("Enter a  Mobile No."),
//       address: Yup.string().required("Enter Address"),
//       amc_divisional_office: Yup.string().required("Enter Festival Name"),
//       police_station: Yup.string().required("Enter Festival Name"),
//       traffice_office: Yup.string().required("Enter Mandal Name"),
//       fire_station: Yup.string().required("Enter Mandal Address"),
//       shop_name: Yup.string().required("Enter Mandal Registration Number"),
//       shop_owner_name: Yup.string().required("Enter Mandap Length"),
//       shop_adderess: Yup.string().required("Enter Mandap Length"),
//       applicant: Yup.string().required("Enter Mandap Width"),
//       appl_type: Yup.string().required("Enter Mandap Area"),
//       murti_type: Yup.string().required("Enter Mandap Duration"),
//       registration: Yup.string().required("Enter Mandal Start Date"),
//       start_date: Yup.string().required("Enter Mandal End Date"),
//       last_date: Yup.string().required("Enter Kaman Address"),
//       place_height: Yup.string().required("Enter Kaman Number"),
//       fire_measures_implemented: Yup.string().required("Enter Kaman Height"),
//       pathway_clear: Yup.string().required("Enter Number Of Banner"),
//       place: Yup.string().required("Enter Comlaint Against Application"),
//       place_type: Yup.string().required("Enter Comlaint Against Application"),
//       adharcard: Yup.mixed()
//         .required("Please select an image")
//         .test("fileSize", "File size is too large", (value) => {
//           return value ? value.size <= 5000000 : true;
//         }),
//       affidavit_type: Yup.mixed()
//         .required("Please select an image")
//         .test("fileSize", "File size is too large", (value) => {
//           return value ? value.size <= 5000000 : true;
//         }),
//       place_owner_noc: Yup.mixed()
//         .required("Please select an image")
//         .test("fileSize", "File size is too large", (value) => {
//           return value ? value.size <= 5000000 : true;
//         }),
//       property_tax_receipt: Yup.mixed()
//         .required("Please select an image")
//         .test("fileSize", "File size is too large", (value) => {
//           return value ? value.size <= 5000000 : true;
//         }),
//     }),
//     onSubmit: (values, action) => {
//       if (!values.adharcard) {
//         toast.error("Please select an Aadhar Card image");
//         return;
//       }
//       if (!values.affidavit_type) {
//         toast.error("Please select a Member List Mobile image");
//         return;
//       }
//       if (!values.place_owner_noc) {
//         toast.error("Please select a Traffic Declaration image");
//         return;
//       }
//       if (!values.property_tax_receipt) {
//         toast.error("Please select a Site Location Map image");
//         return;
//       }

//       const formData = new FormData();
//       formData.append("name", values.name);
//       formData.append("mobile", values.mobile);
//       formData.append("email", values.email);
//       formData.append("address", values.address);
//       formData.append("amc_divisional_office", values.amc_divisional_office);
//       formData.append("traffice_office", values.traffice_office);
//       formData.append("fire_station", values.fire_station);
//       formData.append("shop_name", values.shop_name);
//       formData.append("shop_owner_name", values.shop_owner_name);
//       formData.append("shop_adderess", values.shop_adderess);
//       formData.append("applicant", values.applicant);
//       formData.append("appl_type", values.appl_type);
//       formData.append("murti_type", values.murti_type);
//       formData.append("registration", values.registration);
//       formData.append("start_date", values.start_date);
//       formData.append("last_date", values.last_date);
//       formData.append("place_height", values.place_height);
//       formData.append(
//         "fire_measures_implemented",
//         values.fire_measures_implemented
//       );
//       formData.append("place", values.place);
//       formData.append("place_type", values.place_type);
//       formData.append("adharcard", values.adharcard);
//       formData.append("affidavit_type", values.affidavit_type);
//       formData.append("place_owner_noc", values.place_owner_noc);
//       formData.append("property_tax_receipt", values.property_tax_receipt);

//       server
//         .post("/murticar/murticarapplication", formData, {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         })
//         .then(function (response) {
//           if (response.status === 200 || response.status === 201) {
//             toast.success(response.data.message);
//             formik.resetForm();
//           }
//         })
//         .catch(function (error) {
//           if (error.response?.data?.message)
//             toast.error(error.response.data.message);
//           else if (error.response?.data?.error) {
//             toast.error(error.response.data.error);
//           } else toast.error("Failed to connect to server");
//         });
//     },
//   });

//   return (
//     <div>
//       {console.log(formik.values)}
//       {console.log(formik.errors)}

//       <div className="p-2 mt-3" style={{ backgroundColor: "#FFA27F" }}>
//         <h3 className="container fw-bold align-items-center justify-content-center text-center">
//           मूर्तिकार/स्टॉकिस्ट परवानगी/मूर्ति विक्रेता (Murtikar/Stockist/Murti
//           Saler Permission)
//         </h3>
//       </div>

//       <div className="container mt-4">
//         <form onSubmit={formik.handleSubmit}>
//           {/* अर्जदाराची माहिती */}
//           <div className="card mb-3">
//             <div className="card-header">अर्जदाराची माहिती</div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group col-md-3">
//                   <label>
//                     अर्जदाराचे नांव:<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formik.values.name}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="अर्जदाराचे नांव:"
//                   />
//                   {formik.errors.name ? (
//                     <p className="text-danger">{formik.errors.name}</p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     मोबाईल क्रमांक:<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="mobile"
//                     value={formik.values.mobile}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="मोबाईल क्रमांक:"
//                   />
//                   {formik.errors.mobile ? (
//                     <p className="text-danger">{formik.errors.mobile}</p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     ई-मेल:<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formik.values.email}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="ई-मेल:"
//                   />
//                   {formik.errors.email ? (
//                     <p className="text-danger">{formik.errors.email}</p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     संपूर्ण पत्ता:<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="address"
//                     value={formik.values.address}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="संपूर्ण पत्ता:"
//                   />
//                   {formik.errors.address ? (
//                     <p className="text-danger">{formik.errors.address}</p>
//                   ) : null}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/*विभाग */}
//           <div className="card mb-3">
//             <div className="card-header">विभाग</div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group  col-md-3">
//                   <label>
//                     प्रभाग कार्यालय : <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     name="amc_divisional_office"
//                     className="form-control"
//                     value={formik.values.amc_divisional_office}
//                     onChange={formik.handleChange}
//                   >
//                     <option>--Select प्रभाग कार्यालय--</option>
//                     <option value="सावेडी">प्रभाग समिती क्र. ०१ सावेडी</option>
//                     <option value="वसुली">
//                       प्रभाग समिती क्र. ०२ शहर वसुली{" "}
//                     </option>
//                     <option value="झेंडीगेट">
//                       प्रभाग समिती क्र. ०३ झेंडीगेट{" "}
//                     </option>
//                     <option value="बुरुडगांव">
//                       प्रभाग समिती क्र. ०४ बुरुडगांव{" "}
//                     </option>

//                     {/* Add options here */}
//                   </select>

//                   {formik.errors.amc_divisional_office ? (
//                     <p className="text-danger">
//                       {formik.errors.amc_divisional_office}
//                     </p>
//                   ) : null}
//                 </div>

//                 <div className="form-group col-md-3">
//                   <label>
//                     पोलीस स्टेशन / ठाणे : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <select
//                     className="form-control"
//                     name="police_station"
//                     value={formik.values.police_station}
//                     onChange={formik.handleChange}
//                   >
//                     <option>--Select पोलीस स्टेशन / ठाणे--</option>
//                     <option value="तोफखाना पोलिस स्टेशन">
//                       तोफखाना पोलिस स्टेशन
//                     </option>
//                     <option value="कोतवाली पोलिस स्टेशन">
//                       कोतवाली पोलिस स्टेशन
//                     </option>
//                     <option value="एम. आय. डी.सी. पोलिस स्टेशन">
//                       एम. आय. डी.सी. पोलिस स्टेशन{" "}
//                     </option>
//                     <option value="भिंगार कॅम्प पोलिस स्टेशन">
//                       भिंगार कॅम्प पोलिस स्टेशन
//                     </option>

//                     {/* Add options here */}
//                   </select>
//                   {formik.errors.police_department ? (
//                     <p className="text-danger">
//                       {formik.errors.police_department}
//                     </p>
//                   ) : null}
//                 </div>

//                 <div className="form-group col-md-3">
//                   <label>
//                     शहर वाहतूक विभाग :<span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="traffice_office"
//                     value={formik.values.traffice_office}
//                     onChange={formik.handleChange}
//                     placeholder="शहर वाहतूक विभाग:"
//                   />
//                   {formik.errors.traffice_office ? (
//                     <p className="text-danger">
//                       {formik.errors.traffice_office}
//                     </p>
//                   ) : null}
//                 </div>

//                 <div className="form-group col-md-3">
//                   <label>
//                     अग्निशमन केंद्र (फायर स्टेशन):{" "}
//                     <span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     name="fire_station"
//                     value={formik.values.fire_station}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="अग्निशमन केंद्र:
// "
//                   />
//                   {formik.errors.fire_station ? (
//                     <p className="text-danger">{formik.errors.fire_station}</p>
//                   ) : null}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* अर्जीदाराची माहिती */}
//           <div className="card mb-3">
//             <div className="card-header">
//               मूर्तिकार / साठवणूकदार / कारखानदार / विक्रेता गाळ्याची / जागेची
//               माहिती
//             </div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group col-md-3">
//                   <label>
//                     गाळ्याचे नाव: <span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     name="shop_name"
//                     value={formik.values.shop_name}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="गाळ्याचे नाव :
// "
//                   />
//                   {formik.errors.shop_name ? (
//                     <p className="text-danger">{formik.errors.shop_name}</p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     गाळाधारकाचे नाव : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     name="shop_owner_name"
//                     value={formik.values.shop_owner_name}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="गाळाधारकाचे नाव :
// "
//                   />
//                   {formik.errors.shop_owner_name ? (
//                     <p className="text-danger">
//                       {formik.errors.shop_owner_name}
//                     </p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     गाळ्याच्या जागेचा पत्ता :{" "}
//                     <span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     name="shop_adderess"
//                     value={formik.values.shop_adderess}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="गाळ्याच्या जागेचा पत्ता
// "
//                   />
//                   {formik.errors.shop_adderess ? (
//                     <p className="text-danger">{formik.errors.shop_adderess}</p>
//                   ) : null}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* अर्जीदाराची माहिती */}
//           <div className="card mb-3">
//             <div className="card-header">
//               मूर्तिकार / साठवणूकदार / कारखानदार / विक्रेता तपशील
//             </div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group col-md-3">
//                   <label>
//                     अर्जदार : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <select
//                     className="form-control"
//                     name="applicant"
//                     value={formik.values.applicant}
//                     onChange={formik.handleChange}
//                   >
//                     <option value="" selected="selected">
//                       --Select अर्जदार: --
//                     </option>
//                     <option value="murti maker">मूर्तिकार (Murti Maker)</option>
//                     <option value="stockist">साठवणूकदार(Stockist)</option>
//                     <option value="factory owner">
//                       कारखानदार (Factory Owner)
//                     </option>
//                     <option value="murti seller">विक्रेता (Murti Saler)</option>
//                   </select>
//                   {formik.errors.applicant ? (
//                     <p className="text-danger">{formik.errors.applicant}</p>
//                   ) : null}
//                 </div>

//                 <div className="form-group col-md-3">
//                   <label>
//                     अर्ज प्रकार : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <select
//                     className="form-control"
//                     name="appl_type"
//                     value={formik.values.appl_type}
//                     onChange={formik.handleChange}
//                   >
//                     <option value="" selected="selected">
//                       --Select अर्ज प्रकार:--
//                     </option>
//                     <option value="1">
//                       (शाडू /पर्यावरणपूरक साहित्याने मूर्ती घडविणारे मूर्तिकार
//                       परवानगी) (Eco Friendly Murtikar Permission)
//                     </option>
//                     <option value="2">
//                       (शाडू /पर्यावरणपूरक साहित्याने मूर्ती घडविणारे मूर्तिकार
//                       परवानगी) / (POP मूर्ती घडविणारे मूर्तिकार परवानगी) (Eco
//                       Friendly/POP Murtikars Permission
//                     </option>
//                     <option value="3">
//                       (मूर्त्या साठवणूकदारांचे / कारखानदारांचे हमीपत्र)/विक्री
//                       करणारे / (Stockists/Factory/Saler )
//                     </option>
//                   </select>
//                   {formik.errors.appl_type ? (
//                     <p className="text-danger">{formik.errors.appl_type}</p>
//                   ) : null}
//                 </div>

//                 <div className="form-group col-md-3">
//                   <label>
//                     मूर्तीचा प्रकार : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <select
//                     className="form-control"
//                     name="murti_type"
//                     value={formik.values.murti_type}
//                     onChange={formik.handleChange}
//                   >
//                     <option value="" selected="selected">
//                       --Select मूर्तीचा प्रकार: --
//                     </option>
//                     <option value="non pop">
//                       शाडू /पर्यावरणपूरक मूर्ती (Non-POP)
//                     </option>
//                     <option value="pop">POP मूर्ती (POP)</option>
//                     <option value="both">
//                       शाडू /पर्यावरणपूरक मूर्ती / POP मूर्ती (Both)
//                     </option>
//                   </select>
//                   {formik.errors.murti_type ? (
//                     <p className="text-danger">{formik.errors.murti_type}</p>
//                   ) : null}
//                 </div>

//                 <div className="form-group col-md-3">
//                   <label>नोंदणी क्रमांक (असल्यास ) :</label>

//                   <input
//                     type="text"
//                     name="registration"
//                     value={formik.values.registration}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="नोंदणी क्रमांक
// "
//                   />
//                   {formik.errors.registration ? (
//                     <p className="text-danger">{formik.errors.registration}</p>
//                   ) : null}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* अर्जीदाराची माहिती */}
//           <div className="card mb-3">
//             <div className="card-header">
//               मूर्तिकार / साठवणूकदार / कारखानदार / विक्रेता कालावधी
//             </div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group col-md-3">
//                   <label>
//                     सुरू करणायचा दिनांक<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="date"
//                     name="start_date"
//                     value={formik.values.start_date}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="सुरू करणायचा दिनांक
// "
//                   />
//                   {formik.errors.start_date ? (
//                     <p className="text-danger">{formik.errors.start_date}</p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     अंतिम दिनांक<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="date"
//                     name="last_date"
//                     value={formik.values.last_date}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="अंतिम दिनांक
// "
//                   />
//                   {formik.errors.last_date ? (
//                     <p className="text-danger">{formik.errors.last_date}</p>
//                   ) : null}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* अर्जीदाराची माहिती */}
//           <div className="card mb-3">
//             <div className="card-header">ईतर माहिती</div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group col-md-3">
//                   <label>
//                     जागेची लांबी (फुट) : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     name="place_height"
//                     value={formik.values.place_height}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="जागेची लांबी (फुट) "
//                   />
//                   {formik.errors.place_height ? (
//                     <p className="text-danger">{formik.errors.place_height}</p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     जागेची रुंदी (फुट) : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     name="place_width"
//                     value={formik.values.place_width}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="जागेची रुंदी (फुट)
// "
//                   />
//                   {formik.errors.place_width ? (
//                     <p className="text-danger">{formik.errors.place_width}</p>
//                   ) : null}
//                 </div>

//                 <div className="form-group col-md-3">
//                   <label>
//                     जागेचे क्षेत्रफळ : <span className="text-danger">*</span>{" "}
//                   </label>
//                   <input
//                     type="text"
//                     name="place_area"
//                     value={formik.values.place_area}
//                     onChange={formik.handleChange}
//                     className="form-control"
//                     placeholder="जागेचे क्षेत्रफळ"
//                   />
//                   {formik.errors.place_area ? (
//                     <p className="text-danger">{formik.errors.place_area}</p>
//                   ) : null}
//                 </div>

//                 <div className="form-group my-3 col-md-4">
//                   <label>
//                     आग प्रतिबंधक उपाय योजना निकषांची अंमलबजावणी करण्यात आली आहे
//                     का ?<span className="text-danger">*</span>:
//                   </label>
//                   <div>
//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         id="fire_measures_implemented"
//                         value="fire_measures_implemented"
//                         name="fire_measures_implemented"
//                         onChange={formik.handleChange}
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="fire_measures_implemented"
//                       >
//                         होय
//                       </label>
//                     </div>

//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="fire_measures_implemented"
//                         onChange={formik.handleChange}
//                         id="loudspeakerNo"
//                         value="fire_measures_implemented"
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="loudspeakerNo"
//                       >
//                         नाही
//                       </label>
//                     </div>
//                   </div>
//                   {formik.errors.fire_measures_implemented ? (
//                     <p className="text-danger">
//                       {formik.errors.fire_measures_implemented}
//                     </p>
//                   ) : null}
//                 </div>

//                 <div className="form-group my-3 col-md-4">
//                   <label>
//                     नागरीकांना जाण्या-येण्यासाठी पुरेसा रास्ता / फुटपाथ मोकळा
//                     आहे का ?:<span className="text-danger">*</span>
//                   </label>
//                   <div>
//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="pathway_clear"
//                         onChange={formik.handleChange}
//                         id="loudspeakerYes"
//                         value="pathway_clear"
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="pathway_clear"
//                       >
//                         होय
//                       </label>
//                     </div>

//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         id="pathway_clear"
//                         value="no"
//                         name="pathway_clear"
//                         onChange={formik.handleChange}
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="pathway_clear"
//                       >
//                         नाही
//                       </label>
//                     </div>
//                   </div>
//                   {formik.errors.pathway_clear ? (
//                     <p className="text-danger">{formik.errors.pathway_clear}</p>
//                   ) : null}
//                 </div>

//                 <div className="form-group my-3 col-md-4">
//                   <label>
//                     जागा :<span className="text-danger">*</span>
//                   </label>
//                   <div>
//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="place"
//                         onChange={formik.handleChange}
//                         id="place"
//                         value="private"
//                       />
//                       <label className="form-check-label" htmlFor="place">
//                         खाजगी
//                       </label>
//                     </div>

//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="place"
//                         onChange={formik.handleChange}
//                         id="place"
//                         value="municipal"
//                       />
//                       <label className="form-check-label" htmlFor="place">
//                         महानगरपालिका
//                       </label>
//                     </div>
//                   </div>
//                   {formik.errors.place ? (
//                     <p className="text-danger">{formik.errors.place}</p>
//                   ) : null}
//                 </div>

//                 <div className="form-group my-3 col-md-4">
//                   <label>
//                     जागेचा प्रकार: <span className="text-danger">*</span>
//                   </label>
//                   <div>
//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="place_type"
//                         onChange={formik.handleChange}
//                         value="shop"
//                         id="loudspeakerYes"
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="loudspeakerYes"
//                       >
//                         गाळा
//                       </label>
//                     </div>

//                     <div className="form-check form-check-inline">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         id="loudspeakerNo"
//                         name="place_type"
//                         onChange={formik.handleChange}
//                         value="open space"
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="loudspeakerNo"
//                       >
//                         खुली जागा
//                       </label>
//                     </div>
//                     {formik.errors.place_type ? (
//                       <p className="text-danger">{formik.errors.place_type}</p>
//                     ) : null}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="card">
//             <div className="card-header">
//               <h5 className="card-header">हमीपत्र माहिती</h5>
//             </div>
//             <ul className="list-group list-group-flush card-body">
//               <li
//                 className="list-group-item d-flex justify-content-between align-items-center"
//                 style={{ backgroundColor: "#cdbf5c3b" }}
//               >
//                 शाडू /पर्यावरणपूरक साहित्याने मूर्ती घडविणाऱ्या /विक्री करणाऱ्या
//                 मूर्तीकारांचे हमीपत्र
//                 <button className="btn btn-primary">Download</button>
//               </li>
//               <li
//                 className="list-group-item d-flex justify-content-between align-items-center"
//                 style={{ backgroundColor: "#cdbf5c3b" }}
//               >
//                 शाडू /पर्यावरणपूरक साहित्याने /विक्री करणारे /POP मूर्ती
//                 घडविणाऱ्या /विक्री करणारे मूर्तीकारांचे हमीपत्र
//                 <button className="btn btn-primary">Download</button>
//               </li>
//               <li
//                 className="list-group-item d-flex justify-content-between align-items-center"
//                 style={{ backgroundColor: "#cdbf5c3b" }}
//               >
//                 मूर्त्या साठवणूकदारांचे / कारखानदारांचे हमीपत्र
//                 <button className="btn btn-primary">Download</button>
//               </li>
//             </ul>
//           </div>

//           {/* Document Upload Section */}
//           <div className="card mt-4">
//             <div className="card-header">
//               <h5 className="card-header">जोडण्याची कागदपत्रे</h5>
//             </div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group col-md-3">
//                   <label>
//                     आधार कार्ड(pdf, jpg, jpeg format):{" "}
//                     <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="file"
//                     name="adharcard"
//                     className="form-control-file"
//                     onChange={(event) => {
//                       formik.setFieldValue(
//                         "adharcard",
//                         event.currentTarget.files[0]
//                       );
//                     }}
//                   />
//                   {formik.errors.adharcard ? (
//                     <p className="text-danger">{formik.errors.adharcard}</p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     हमीपत्र (मूर्तिकार / स्टॉकिस्ट अर्ज प्रकार नुसार)(pdf, jpg,
//                     jpeg format) :<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="file"
//                     name="affidavit_type"
//                     className="form-control-file"
//                     onChange={(event) => {
//                       formik.setFieldValue(
//                         "affidavit_type",
//                         event.currentTarget.files[0]
//                       );
//                     }}
//                   />
//                   {formik.errors.affidavit_type ? (
//                     <p className="text-danger">
//                       {formik.errors.affidavit_type}
//                     </p>
//                   ) : null}
//                 </div>
//                 <br></br>
//                 <div className="form-group col-md-3">
//                   <label>
//                     जागा मालकाची NOC(pdf, jpg, jpeg format):{" "}
//                     <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="file"
//                     name="place_owner_noc"
//                     className="form-control-file"
//                     onChange={(event) => {
//                       formik.setFieldValue(
//                         "place_owner_noc",
//                         event.currentTarget.files[0]
//                       );
//                     }}
//                   />
//                   {formik.errors.place_owner_noc ? (
//                     <p className="text-danger">
//                       {formik.errors.place_owner_noc}
//                     </p>
//                   ) : null}
//                 </div>
//                 <div className="form-group col-md-3">
//                   <label>
//                     मालमत्ता कर पावती (property tax receipt) (pdf, jpg, jpeg
//                     format):
//                     <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="file"
//                     name="property_tax_receipt"
//                     className="form-control-file"
//                     onChange={(event) => {
//                       formik.setFieldValue(
//                         "property_tax_receipt",
//                         event.currentTarget.files[0]
//                       );
//                     }}
//                   />
//                   {formik.errors.property_tax_receipt ? (
//                     <p className="text-danger">
//                       {formik.errors.property_tax_receipt}
//                     </p>
//                   ) : null}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Terms and Conditions Section */}
//           <div className="card mt-4">
//             <div className="card-header">
//               <h5 className="card-header">अटी व शर्ती</h5>
//             </div>
//             <div className="card-body">
//               <div className="form-check">
//                 <input
//                   type="checkbox"
//                   className="form-check-input"
//                   id="termsCheck"
//                 />
//                 <label className="form-check-label" htmlFor="termsCheck">
//                   मी याद्वारे जाहिर करतो/ करते की, मला याबाबत वेगवेगळे अधिनियम,
//                   नियम व मा. उच्च न्याायालयाच्या विविध निर्देशांची जाणीव आहे. मी
//                   याद्वारे असेही जाहिर करतो की, मी वर दिलेली माहिती माझ्या
//                   समजुतीप्रमाणे खरी व बिनचूक आहे आणि उपरोक्त माहिती चुकीची /
//                   खोटी आढळल्यास माझ्यावर कायदेशीर कारवाई करण्यात येईल याची मला
//                   जाणीव आहे. I hereby declare that I am aware of different laws,
//                   rules, regulations and Hon'ble High Court's orders in this
//                   regard.I also declare that the information submitted by me is
//                   true and correct to the best of my knowledge And I am aware
//                   that if it is found incorrect, I will be liable for penal
//                   action/punishment as per law.
//                   <span className="text-danger">*</span>
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Submit Button */}
//           <button type="submit" className="btn btn-primary  mt-2">
//             Submit
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default MurtikarForm;

import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { server } from "../../common";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  FormControlLabel,
  RadioGroup,
  Checkbox,
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import configContext from "../../contexts/configContext/configContexts";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

const swalalert = withReactContent(Swal);

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: 8,
}));

const StyledMainCardHeader = styled(CardHeader)(({ theme }) => ({
  backgroundColor: "#2E3B5E",
  color: theme.palette.common.white,
  fontWeight: 600,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1.5, 4),
  fontSize: "1.1rem",
  fontWeight: 500,
  borderRadius: 8,
  textTransform: "none",
  "&:disabled": {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.grey[600],
  },
}));

const initialValues = {
  name: "",
  mobile: "",
  email: "",
  address: "",
  amc_divisional_office: "",
  police_station: "",
  traffice_office: "",
  fire_station: "",
  shop_name: "",
  shop_owner_name: "",
  shop_adderess: "",
  applicant: "",
  appl_type: "",
  murti_type: "",
  registration: "",
  start_date: "",
  last_date: "",
  place_height: "",
  fire_measures_implemented: "",
  pathway_clear: "",
  place: "",
  place_type: "",
  adharcard: null,
  affidavit_type: null,
  place_owner_noc: null,
  property_tax_receipt: null,
};

const MurtikarForm = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);
  const { t } = useTranslation();
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      name: Yup.string().required("Enter a Fullname"),
      email: Yup.string().required("Enter a Email Id"),
      mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Please enter a valid Indian mobile number")
        .required("Enter a Mobile No."),
      address: Yup.string().required("Enter Address"),
      amc_divisional_office: Yup.string().required("Enter Festival Name"),
      police_station: Yup.string().required("Enter Festival Name"),
      traffice_office: Yup.string().required("Enter Mandal Name"),
      fire_station: Yup.string().required("Enter Mandal Address"),
      shop_name: Yup.string().required("Enter Mandal Registration Number"),
      shop_owner_name: Yup.string().required("Enter Mandap Length"),
      shop_adderess: Yup.string().required("Enter Mandap Length"),
      applicant: Yup.string().required("Enter Mandap Width"),
      appl_type: Yup.string().required("Enter Mandap Area"),
      murti_type: Yup.string().required("Enter Mandap Duration"),
      registration: Yup.string().required("Enter Mandal Start Date"),
      start_date: Yup.string().required("Enter Mandal End Date"),
      last_date: Yup.string().required("Enter Kaman Address"),
      place_height: Yup.string().required("Enter Kaman Number"),
      fire_measures_implemented: Yup.string().required("Enter Kaman Height"),
      pathway_clear: Yup.string().required("Enter Number Of Banner"),
      place: Yup.string().required("Enter Comlaint Against Application"),
      place_type: Yup.string().required("Enter Comlaint Against Application"),
      adharcard: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
      affidavit_type: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
      place_owner_noc: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
      property_tax_receipt: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (!values.adharcard) {
        toast.error("Please select an Aadhar Card image");
        return;
      }
      if (!values.affidavit_type) {
        toast.error("Please select a Member List Mobile image");
        return;
      }
      if (!values.place_owner_noc) {
        toast.error("Please select a Traffic Declaration image");
        return;
      }
      if (!values.property_tax_receipt) {
        toast.error("Please select a Site Location Map image");
        return;
      }

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("mobile", values.mobile);
      formData.append("email", values.email);
      formData.append("address", values.address);
      formData.append("amc_divisional_office", values.amc_divisional_office);
      formData.append("traffice_office", values.traffice_office);
      formData.append("fire_station", values.fire_station);
      formData.append("shop_name", values.shop_name);
      formData.append("shop_owner_name", values.shop_owner_name);
      formData.append("shop_adderess", values.shop_adderess);
      formData.append("applicant", values.applicant);
      formData.append("appl_type", values.appl_type);
      formData.append("murti_type", values.murti_type);
      formData.append("registration", values.registration);
      formData.append("start_date", values.start_date);
      formData.append("last_date", values.last_date);
      formData.append("place_height", values.place_height);
      formData.append(
        "fire_measures_implemented",
        values.fire_measures_implemented
      );
      formData.append("place", values.place);
      formData.append("place_type", values.place_type);
      formData.append("adharcard", values.adharcard);
      formData.append("affidavit_type", values.affidavit_type);
      formData.append("place_owner_noc", values.place_owner_noc);
      formData.append("property_tax_receipt", values.property_tax_receipt);

      // server
      //   .post("/murticar/murticarapplication", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then(function (response) {
      //     if (response.status === 200 || response.status === 201) {
      //       toast.success(response.data.message);
      //       formik.resetForm();
      //     }
      //   })
      //   .catch(function (error) {
      //     if (error.response?.data?.message)
      //       toast.error(error.response.data.message);
      //     else if (error.response?.data?.error) {
      //       toast.error(error.response.data.error);
      //     } else toast.error("Failed to connect to server");
      //   });

      swalalert
        .fire({
          title: "परवानगी सबमिट करायची आहे का?",
          text: `परवानगी सबमिट करायची आहे का?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "होय",
          cancelButtonText: "नाही",
          buttonsStyling: true,
        })
        .then((swalObject) => {
          if (swalObject.isConfirmed) {
            setProcessing(true);
            setProgress(10);
            server
              .post(`/murticar/murticarapplication`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then(function (response) {
                if (response.status === 200 || response.status === 201) {
                  swalalert.fire({
                    title: "सफलता!",
                    text: `कृपया हा अर्ज आयडी जतन करा आपल्या अर्जाच्या स्थितीचा मागोवा ठेवण्यासाठी ${response.data.id}`,
                    icon: "success",
                  });
                  setProgress(100);
                  formik.resetForm();
                  formik.setFieldValue("");
                }
                setProcessing(false);
              })
              .catch((error) => {
                toast.error(
                  error.response?.data?.message ||
                    error.response?.data?.error ||
                    "सर्व्हरशी कनेक्ट करणे अयशस्वी झाले"
                );
                setProcessing(false);
                setProgress(100);
              });
          }
        });
    },
  });
  return (
    <div className="container mt-4">
      {processing && <Loader loading={processing} />}

      <StyledCard>
        <h4
          style={{
            backgroundColor: "#81BFDA",
            padding: "10px",
            color: "black",
          }}
        >
          {t("murticarform.Murtikar/Stockist/Murti Saler Application Form")}
        </h4>
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            {/* अर्जदाराची माहिती */}
            <StyledCard>
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t("murticarform.Applcant Details")}
              </h6>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Applicant Name")}
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      error={formik.touched.name && Boolean(formik.errors.name)}
                      helperText={formik.touched.name && formik.errors.name}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Mobile Number")}
                      name="mobile"
                      value={formik.values.mobile}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.mobile && Boolean(formik.errors.mobile)
                      }
                      helperText={formik.touched.mobile && formik.errors.mobile}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Email")}
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Address")}
                      name="address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.address && Boolean(formik.errors.address)
                      }
                      helperText={
                        formik.touched.address && formik.errors.address
                      }
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* विभाग */}
            <StyledCard>
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t("murticarform.Division")}
              </h6>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <FormControl
                      fullWidth
                      error={
                        formik.touched.amc_divisional_office &&
                        Boolean(formik.errors.amc_divisional_office)
                      }
                    >
                      <InputLabel>प्रभाग कार्यालय :*</InputLabel>
                      <Select
                        name="amc_divisional_office"
                        value={formik.values.amc_divisional_office}
                        onChange={formik.handleChange}
                        label="प्रभाग कार्यालय :*"
                      >
                        <MenuItem value="">--Select प्रभाग कार्यालय--</MenuItem>
                        <MenuItem value="सावेडी">
                          प्रभाग समिती क्र. ०१ सावेडी
                        </MenuItem>
                        <MenuItem value="वसुली">
                          प्रभाग समिती क्र. ०२ शहर वसुली
                        </MenuItem>
                        <MenuItem value="झेंडीगेट">
                          प्रभाग समिती क्र. ०३ झेंडीगेट
                        </MenuItem>
                        <MenuItem value="बुरुडगांव">
                          प्रभाग समिती क्र. ०४ बुरुडगांव
                        </MenuItem>
                      </Select>
                      {formik.touched.amc_divisional_office &&
                        formik.errors.amc_divisional_office && (
                          <Typography color="error">
                            {formik.errors.amc_divisional_office}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormControl
                      fullWidth
                      error={
                        formik.touched.police_station &&
                        Boolean(formik.errors.police_station)
                      }
                    >
                      <InputLabel>
                        {t("murticarform.Police Station")}
                      </InputLabel>
                      <Select
                        name="police_station"
                        value={formik.values.police_station}
                        onChange={formik.handleChange}
                        label="पोलीस स्टेशन / ठाणे :*"
                      >
                        <MenuItem value="">
                          --Select पोलीस स्टेशन / ठाणे--
                        </MenuItem>
                        <MenuItem value="तोफखाना पोलिस स्टेशन">
                          तोफखाना पोलिस स्टेशन
                        </MenuItem>
                        <MenuItem value="कोतवाली पोलिस स्टेशन">
                          कोतवाली पोलिस स्टेशन
                        </MenuItem>
                        <MenuItem value="एम. आय. डी.सी. पोलिस स्टेशन">
                          एम. आय. डी.सी. पोलिस स्टेशन
                        </MenuItem>
                        <MenuItem value="भिंगार कॅम्प पोलिस स्टेशन">
                          भिंगार कॅम्प पोलिस स्टेशन
                        </MenuItem>
                      </Select>
                      {formik.touched.police_station &&
                        formik.errors.police_station && (
                          <Typography color="error">
                            {formik.errors.police_station}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.City Transport Department")}
                      name="traffice_office"
                      value={formik.values.traffice_office}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.traffice_office &&
                        Boolean(formik.errors.traffice_office)
                      }
                      helperText={
                        formik.touched.traffice_office &&
                        formik.errors.traffice_office
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.fire station")}
                      name="fire_station"
                      value={formik.values.fire_station}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.fire_station &&
                        Boolean(formik.errors.fire_station)
                      }
                      helperText={
                        formik.touched.fire_station &&
                        formik.errors.fire_station
                      }
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* मूर्तिकार / साठवणूकदार / कारखानदार / विक्रेता गाळ्याची / जागेची माहिती */}
            <StyledCard>
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t(
                  "murticarform.Sculptor / Storekeeper / Manufacturer / Seller Information"
                )}
              </h6>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Shop Name")}
                      name="shop_name"
                      value={formik.values.shop_name}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.shop_name &&
                        Boolean(formik.errors.shop_name)
                      }
                      helperText={
                        formik.touched.shop_name && formik.errors.shop_name
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Name of the owner")}
                      name="shop_owner_name"
                      value={formik.values.shop_owner_name}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.shop_owner_name &&
                        Boolean(formik.errors.shop_owner_name)
                      }
                      helperText={
                        formik.touched.shop_owner_name &&
                        formik.errors.shop_owner_name
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Shop Address")}
                      name="shop_adderess"
                      value={formik.values.shop_adderess}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.shop_adderess &&
                        Boolean(formik.errors.shop_adderess)
                      }
                      helperText={
                        formik.touched.shop_adderess &&
                        formik.errors.shop_adderess
                      }
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* मूर्तिकार / साठवणूकदार / कारखानदार / विक्रेता तपशील */}
            <StyledCard>
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t(
                  "murticarform.Sculptor / Storekeeper / Manufacturer / Seller Details"
                )}
              </h6>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <FormControl
                      fullWidth
                      error={
                        formik.touched.applicant &&
                        Boolean(formik.errors.applicant)
                      }
                    >
                      <InputLabel>{t("murticarform.Applicant")}</InputLabel>
                      <Select
                        name="applicant"
                        value={formik.values.applicant}
                        onChange={formik.handleChange}
                        label={t("murticarform.Applicant")}
                      >
                        <MenuItem value="">--Select अर्जदार: --</MenuItem>
                        <MenuItem value="murti maker">
                          मूर्तिकार (Murti Maker)
                        </MenuItem>
                        <MenuItem value="stockist">
                          साठवणूकदार(Stockist)
                        </MenuItem>
                        <MenuItem value="factory owner">
                          कारखानदार (Factory Owner)
                        </MenuItem>
                        <MenuItem value="murti seller">
                          विक्रेता (Murti Saler)
                        </MenuItem>
                      </Select>
                      {formik.touched.applicant && formik.errors.applicant && (
                        <Typography color="error">
                          {formik.errors.applicant}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl
                      fullWidth
                      error={
                        formik.touched.appl_type &&
                        Boolean(formik.errors.appl_type)
                      }
                    >
                      <InputLabel>
                        {" "}
                        {t("murticarform.Application Type")}
                      </InputLabel>
                      <Select
                        name="appl_type"
                        value={formik.values.appl_type}
                        onChange={formik.handleChange}
                        label="अर्ज प्रकार :*"
                      >
                        <MenuItem value="">--Select अर्ज प्रकार:--</MenuItem>
                        <MenuItem value="1">
                          (शाडू /पर्यावरणपूरक साहित्याने मूर्ती घडविणारे
                          मूर्तिकार परवानगी) (Eco Friendly Murtikar Permission)
                        </MenuItem>
                        <MenuItem value="2">
                          (शाडू /पर्यावरणपूरक साहित्याने मूर्ती घडविणारे
                          मूर्तिकार परवानगी) / (POP मूर्ती घडविणारे मूर्तिकार
                          परवानगी) (Eco Friendly/POP Murtikars Permission)
                        </MenuItem>
                        <MenuItem value="3">
                          (मूर्त्या साठवणूकदारांचे / कारखानदारांचे
                          हमीपत्र)/विक्री करणारे / (Stockists/Factory/Saler )
                        </MenuItem>
                      </Select>
                      {formik.touched.appl_type && formik.errors.appl_type && (
                        <Typography color="error">
                          {formik.errors.appl_type}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl
                      fullWidth
                      error={
                        formik.touched.murti_type &&
                        Boolean(formik.errors.murti_type)
                      }
                    >
                      <InputLabel>
                        {" "}
                        {t("murticarform.Type of idol")}{" "}
                      </InputLabel>
                      <Select
                        name="murti_type"
                        value={formik.values.murti_type}
                        onChange={formik.handleChange}
                        label="मूर्तीचा प्रकार :*"
                      >
                        <MenuItem value="">
                          --Select मूर्तीचा प्रकार: --
                        </MenuItem>
                        <MenuItem value="non pop">
                          शाडू /पर्यावरणपूरक मूर्ती (Non-POP)
                        </MenuItem>
                        <MenuItem value="pop">POP मूर्ती (POP)</MenuItem>
                        <MenuItem value="both">
                          शाडू /पर्यावरणपूरक मूर्ती / POP मूर्ती (Both)
                        </MenuItem>
                      </Select>
                      {formik.touched.murti_type &&
                        formik.errors.murti_type && (
                          <Typography color="error">
                            {formik.errors.murti_type}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label={t(
                        "murticarform.Registration Number (if available)"
                      )}
                      name="registration"
                      value={formik.values.registration}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.registration &&
                        Boolean(formik.errors.registration)
                      }
                      helperText={
                        formik.touched.registration &&
                        formik.errors.registration
                      }
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* मूर्तिकार / साठवणूकदार / कारखानदार / विक्रेता कालावधी */}
            <StyledCard>
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t(
                  "murticarform.Sculptor / Storekeeper / Manufacturer / Seller Period"
                )}
              </h6>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Starting Date")}
                      name="start_date"
                      type="date"
                      value={formik.values.start_date}
                      onChange={formik.handleChange}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        min: new Date().toISOString().split("T")[0],
                      }}
                      error={
                        formik.touched.start_date &&
                        Boolean(formik.errors.start_date)
                      }
                      helperText={
                        formik.touched.start_date && formik.errors.start_date
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label={t("murticarform.End Date")}
                      name="last_date"
                      type="date"
                      value={formik.values.last_date}
                      onChange={formik.handleChange}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        min: new Date().toISOString().split("T")[0],
                      }}
                      error={
                        formik.touched.last_date &&
                        Boolean(formik.errors.last_date)
                      }
                      helperText={
                        formik.touched.last_date && formik.errors.last_date
                      }
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* ईतर माहिती */}
            <StyledCard>
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t("murticarform.Other Information")}
              </h6>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Length of space (foot)")}
                      name="place_height"
                      value={formik.values.place_height}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.place_height &&
                        Boolean(formik.errors.place_height)
                      }
                      helperText={
                        formik.touched.place_height &&
                        formik.errors.place_height
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Width of space (foot)")}
                      name="place_width"
                      value={formik.values.place_width}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.place_width &&
                        Boolean(formik.errors.place_width)
                      }
                      helperText={
                        formik.touched.place_width && formik.errors.place_width
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label={t("murticarform.Area of ​​the site")}
                      name="place_area"
                      value={formik.values.place_area}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.place_area &&
                        Boolean(formik.errors.place_area)
                      }
                      helperText={
                        formik.touched.place_area && formik.errors.place_area
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl
                      component="fieldset"
                      error={
                        formik.touched.fire_measures_implemented &&
                        Boolean(formik.errors.fire_measures_implemented)
                      }
                    >
                      <Typography variant="subtitle1">
                        {t(
                          "permissionform.Have the fire prevention measures been implemented?"
                        )}
                      </Typography>
                      <RadioGroup
                        name="fire_measures_implemented"
                        value={formik.values.fire_measures_implemented}
                        onChange={formik.handleChange}
                        row
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label={t("murticarform.Yes")}
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label={t("murticarform.No")}
                        />
                      </RadioGroup>
                      {formik.touched.fire_measures_implemented &&
                        formik.errors.fire_measures_implemented && (
                          <Typography color="error">
                            {formik.errors.fire_measures_implemented}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl
                      component="fieldset"
                      error={
                        formik.touched.pathway_clear &&
                        Boolean(formik.errors.pathway_clear)
                      }
                    >
                      <Typography variant="subtitle1">
                        {t(
                          "permissionform.Are there enough roads/footpaths for citizens to move around?"
                        )}
                      </Typography>
                      <RadioGroup
                        name="pathway_clear"
                        value={formik.values.pathway_clear}
                        onChange={formik.handleChange}
                        row
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label={t("murticarform.Yes")}
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label={t("murticarform.No")}
                        />
                      </RadioGroup>
                      {formik.touched.pathway_clear &&
                        formik.errors.pathway_clear && (
                          <Typography color="error">
                            {formik.errors.pathway_clear}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl
                      component="fieldset"
                      error={
                        formik.touched.place && Boolean(formik.errors.place)
                      }
                    >
                      <Typography variant="subtitle1">
                        {t("murticarform.Place")}
                      </Typography>
                      <RadioGroup
                        name="place"
                        value={formik.values.place}
                        onChange={formik.handleChange}
                        row
                      >
                        <FormControlLabel
                          value="private"
                          control={<Radio />}
                          label={t("murticarform.Private")}
                        />
                        <FormControlLabel
                          value="municipal"
                          control={<Radio />}
                          label={t("murticarform.Municipal")}
                        />
                      </RadioGroup>
                      {formik.touched.place && formik.errors.place && (
                        <Typography color="error">
                          {formik.errors.place}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl
                      component="fieldset"
                      error={
                        formik.touched.place_type &&
                        Boolean(formik.errors.place_type)
                      }
                    >
                      <Typography variant="subtitle1">
                        {t("murticarform.Type of space")}
                      </Typography>
                      <RadioGroup
                        name="place_type"
                        value={formik.values.place_type}
                        onChange={formik.handleChange}
                        row
                      >
                        <FormControlLabel
                          value="shop"
                          control={<Radio />}
                          label={t("murticarform.Shop")}
                        />
                        <FormControlLabel
                          value="open space"
                          control={<Radio />}
                          label={t("murticarform.Open Space")}
                        />
                      </RadioGroup>
                      {formik.touched.place_type &&
                        formik.errors.place_type && (
                          <Typography color="error">
                            {formik.errors.place_type}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* हमीपत्र माहिती */}
            <StyledCard>
              {" "}
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                हमीपत्र माहिती
              </h6>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      <ul
                        style={{
                          backgroundColor: "#cdbf5c3b",
                          padding: "1rem",
                          borderRadius: "4px",
                        }}
                      >
                        <li className="d-flex justify-content-between align-items-center">
                          शाडू /पर्यावरणपूरक साहित्याने मूर्ती घडविणाऱ्या
                          /विक्री करणाऱ्या मूर्तीकारांचे हमीपत्र
                          <Button variant="contained" color="primary">
                            Download
                          </Button>
                        </li>
                        <li className="d-flex justify-content-between align-items-center mt-2">
                          शाडू /पर्यावरणपूरक साहित्याने /विक्री करणारे /POP
                          मूर्ती घडविणाऱ्या /विक्री करणारे मूर्तीकारांचे हमीपत्र
                          <Button variant="contained" color="primary">
                            Download
                          </Button>
                        </li>
                        <li className="d-flex justify-content-between align-items-center mt-2">
                          मूर्त्या साठवणूकदारांचे / कारखानदारांचे हमीपत्र
                          <Button variant="contained" color="primary">
                            Download
                          </Button>
                        </li>
                      </ul>
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* जोडण्याची कागदपत्रे */}
            <StyledCard>
              {" "}
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t("permissionform.Upload Documents")}
              </h6>
              <CardContent>
                <Typography variant="subtitle2" color="error" gutterBottom>
                  {t(
                    "permissionform.You can only upload PDF, JPG, PNG, or JPEG files. The maximum file size allowed is 5MB."
                  )}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    {" "}
                    <label>
                      {t("permissionform.Aadhar Card")}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      name="adharcard"
                      className="form-control"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "adharcard",
                          event.currentTarget.files[0]
                        );
                      }}
                      style={{ marginBottom: "1rem" }}
                    />
                    {formik.touched.adharcard && formik.errors.adharcard && (
                      <Typography color="error">
                        {formik.errors.adharcard}
                      </Typography>
                    )}
                  </Grid>{" "}
                  <Grid item xs={12} sm={6}>
                    {" "}
                    <label>
                      {t("murticarform.NOC of the land owner")}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      name="place_owner_noc"
                      className="form-control"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "place_owner_noc",
                          event.currentTarget.files[0]
                        );
                      }}
                      style={{ marginBottom: "1rem" }}
                    />
                    {formik.touched.place_owner_noc &&
                      formik.errors.place_owner_noc && (
                        <Typography color="error">
                          {formik.errors.place_owner_noc}
                        </Typography>
                      )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {" "}
                    <label>
                      {t(
                        "murticarform.Guarantee (as per sculptor/stockist application type)"
                      )}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      name="affidavit_type"
                      className="form-control"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "affidavit_type",
                          event.currentTarget.files[0]
                        );
                      }}
                      style={{ marginBottom: "1rem" }}
                    />
                    {formik.touched.affidavit_type &&
                      formik.errors.affidavit_type && (
                        <Typography color="error">
                          {formik.errors.affidavit_type}
                        </Typography>
                      )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {" "}
                    <label>
                      {t("murticarform.Property tax receipt")}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      name="property_tax_receipt"
                      className="form-control"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "property_tax_receipt",
                          event.currentTarget.files[0]
                        );
                      }}
                      style={{ marginBottom: "1rem" }}
                    />
                    {formik.touched.property_tax_receipt &&
                      formik.errors.property_tax_receipt && (
                        <Typography color="error">
                          {formik.errors.property_tax_receipt}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>

            {/* अटी व शर्ती */}
            <StyledCard>
              {" "}
              <h6 style={{ backgroundColor: "#D1E9F6", padding: "10px" }}>
                {t("permissionform.Terms and Conditions")}
              </h6>
              <CardContent>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      name="termsCheck"
                      color="primary"
                    />
                  }
                  label={
                    <Typography variant="body2">
                      मी याद्वारे जाहिर करतो/ करते की, मला याबाबत वेगवेगळे
                      अधिनियम, नियम व मा. उच्च न्याायालयाच्या विविध निर्देशांची
                      जाणीव आहे. मी याद्वारे असेही जाहिर करतो की, मी वर दिलेली
                      माहिती माझ्या समजुतीप्रमाणे खरी व बिनचूक आहे आणि उपरोक्त
                      माहिती चुकीची / खोटी आढळल्यास माझ्यावर कायदेशीर कारवाई
                      करण्यात येईल याची मला जाणीव आहे.
                      {/* I hereby declare that I
                      am aware of different laws, rules, regulations and Hon'ble
                      High Court's orders in this regard.I also declare that the
                      information submitted by me is true and correct to the
                      best of my knowledge And I am aware that if it is found
                      incorrect, I will be liable for penal action/punishment as
                      per law. */}
                    </Typography>
                  }
                />
              </CardContent>
            </StyledCard>

            <StyledButton
              type="submit"
              variant="contained"
              color="primary"
              disabled={!isChecked}
            >
              Submit
            </StyledButton>
          </form>
        </CardContent>
      </StyledCard>
    </div>
  );
};

export default MurtikarForm;
